<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md6
        xs12
        mb-0
        mt-0
        pb-0
      >
        <h2>{{ $t("modules.bulkPayouts") }}</h2>
      </v-flex>
      <v-flex
        md6
        xs12
        mb-0
        :class="!$vuetify.breakpoint.xs ? 'pt-11 text-right' : 'pb-5'"
        pb-0
      >
        <v-btn
          style="display: inline; margin-top: -6px"
          small
          class="primary"
          @click="showUploadDialog = true"
        >
          {{ $t("globals.createButton") }}
        </v-btn>
      </v-flex>
      <v-flex
        v-if="moduleBulkPayouts && moduleBulkPayouts.data.length > 0"
        md12
      >
        <v-card>
          <v-data-table
            class="text-no-wrap"
            :headers="headers"
            :items="moduleBulkPayouts.data"
            :server-items-length="moduleBulkPayouts.total"
            :items-per-page="params.count"
            :page="params.page"
            :mobile-breakpoint="900"
            @update:items-per-page="loadBulkPayouts($event, 'count')"
            @update:page="loadBulkPayouts($event, 'page')"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span v-text="header.text" />
            </template>
            <template v-slot:item.name="{ item }">
              {{ item.file_name }}
            </template>
            <template v-slot:item.status="{ item }">
              <b
                :class="
                  item.status == 'done'
                    ? 'text-positive'
                    : item.status == 'failed'
                      ? 'text-negative'
                      : ''
                "
              >
                {{ $t("modules." + item.status) }}
              </b>
              <v-tooltip
                v-if="item.comment"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">
                    mdi-information-outline
                  </v-icon>
                </template>
                {{ item.comment }}
              </v-tooltip>
            </template>
            <template v-slot:item.created_at="{ item }">
              <small>{{ item.created_at | moment("L") }}</small>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        class="not-found"
      >
        <v-card>
          <v-icon>mdi-ghost</v-icon>
          <p>{{ $t("modules.bulkPayoutsNotFound") }}</p>
        </v-card>
      </v-flex>
    </v-layout>
    <UploadFileDialog
      :show-dialog="showUploadDialog"
      :whitelabel-uuid="params.whitelabel_uuid"
      @closeUploadFileDialog="closeUploadFileDialog"
    />
  </v-container>
</template>

<script>
import BULK_PAYOUTS_QUERY from "@/graphql/queries/modules/BulkPayouts.gql";
import { mapGetters } from "vuex";
import UploadFileDialog from "./partial/UploadFileDialog.vue";

export default {
  name: "ModuleBulkPayouts",
  components: {
    UploadFileDialog,
  },
  data() {
    return {
      params: {
        whitelabel_uuid: null,
        page: 1,
        count: 5,
      },
      loading: false,
      showUploadDialog: false,
      headers: [
        {
          sortable: false,
          text: this.$t("modules.bulkPayoutsFileName"),
          value: "name",
        },
        {
          sortable: false,
          text: this.$t("modules.bulkPayoutsStatus"),
          value: "status",
        },
        {
          sortable: false,
          text: this.$t("modules.bulkPayoutsAddedAt"),
          value: "created_at",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    moduleData() {
      if (this.getWhiteLabel && this.getWhiteLabel.modules.length > 0) {
        return this.getWhiteLabel.modules.find(
          (item) => item.module == "bulkpayouts"
        );
      }
      return null;
    },
  },
  watch: {
    getWhiteLabel(val) {
      if (this.routeNotAllowed(val, "bulkpayouts")) {
        this.$router.push("/dashboard");
      }
      this.params.whitelabel_uuid = val.uuid;
      this.moduleBulkPayouts = [];
      this.$apollo.queries.moduleBulkPayouts.refetch();
    },
  },
  mounted() {
    if (this.getWhiteLabel) {
      this.params.whitelabel_uuid = this.getWhiteLabel.uuid;
    }
  },
  methods: {
    closeUploadFileDialog(val) {
      this.showUploadDialog = false;
      if (val) {
        this.params.page = 1;
        this.$apollo.queries.moduleBulkPayouts.refetch();
      }
    },
    async loadBulkPayouts(event, from) {
      this.loading = true;
      if (from === "page") {
        this.params.page = event;
      }
      if (from === "count") this.params.count = event;
      await this.$apollo.queries.moduleBulkPayouts.fetchMore({
        variables: this.params,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          return fetchMoreResult;
        },
      });
      this.loading = false;
    },
  },
  apollo: {
    moduleBulkPayouts: {
      fetchPolicy: "network-only",
      query() {
        return BULK_PAYOUTS_QUERY;
      },
      variables() {
        return this.params;
      },
      skip() {
        return !this.params.whitelabel_uuid;
      },
    },
  },
};
</script>
<style lang="scss" scoped></style>
